import { render, staticRenderFns } from "./longread3.vue?vue&type=template&id=c385aae8&"
import script from "./longread3.vue?vue&type=script&lang=js&"
export * from "./longread3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports